import React, { useState } from "react";
import Footer from "../common/Footer";
import Navigation from "../common/Navigation";
import Sidebar from "../common/Sidebar";
import CommonService from "../../services/CommonService";
import Swal from "sweetalert2";

const Pan = () => {

  const [tollCode, setTollCode] = useState("");
  const [tollDetails, setTollDetails] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const handleTollSearch = () => {

    if (!tollCode) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Please enter toll code"
      });
      return;
    }

    setIsLoading(true);

    const payload = {
      toll_code: tollCode,
      toll_name: "",
      state_name: ""
    };

    CommonService.tollDetails(payload)
      .then((response) => {

        console.log("API Response:", response.data);

        if (response.data.status === 200) {

          setTollDetails(response.data.data);

        } else {

          setTollDetails(null);

          Swal.fire({
            icon: "warning",
            title: "Message",
            text: response.data.message
          });

        }

        setIsLoading(false);

      })
      .catch((error) => {

        console.log("API Error:", error);

        Swal.fire({
          icon: "error",
          title: "Error",
          text: error.response?.data?.message || "Something went wrong"
        });

        setIsLoading(false);

      });
  };

  const handleReset = () => {
    setTollCode("");
    setTollDetails(null);
  };

  return (
    <>
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">

          <Sidebar />

          <div className="layout-page">

            <Navigation />

            <div className="content-wrapper">

              <div className="container-xxl flex-grow-1 container-p-y">

                <div className="row">

                  <div className="col-md-12">

                    <div className="card">

                      <div className="card-body">

                        <h5 className="card-header">Toll Details</h5>

                        <hr />

                        {isLoading ? (

                          <div className="d-flex justify-content-center mt-10 loader-overlay">
                            <div className="sk-fold sk-primary">
                              <div className="sk-fold-cube"></div>
                              <div className="sk-fold-cube"></div>
                              <div className="sk-fold-cube"></div>
                              <div className="sk-fold-cube"></div>
                            </div>
                          </div>

                        ) : (

                          <>
                            <div className="row">

                              <div className="col-md-4">

                                <label>Toll Code</label>

                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter Toll Code"
                                  value={tollCode}
                                  onChange={(e) => setTollCode(e.target.value)}
                                />

                              </div>

                            </div>

                            <div className="pt-4">

                              <button
                                className="btn btn-primary me-2"
                                onClick={handleTollSearch}
                              >
                                Search
                              </button>

                              <button
                                className="btn btn-secondary"
                                onClick={handleReset}
                              >
                                Reset
                              </button>

                            </div>
                          </>
                        )}

                        {tollDetails && (

                          <div className="card mt-4">

                            <div className="card-body">

                              <h5>Toll Details Result</h5>

                              <div className="row" style={{ background: "#ebe9e9" }}>

                                <div className="col-md-6">
                                  <b>Toll Code</b>
                                </div>

                                <div className="col-md-6 text-end">
                                  {tollDetails.toll_code || "NA"}
                                </div>

                              </div>

                              <div className="row">

                                <div className="col-md-6">
                                  <b>Toll Name</b>
                                </div>

                                <div className="col-md-6 text-end">
                                  {tollDetails.toll_name || "NA"}
                                </div>

                              </div>

                              <div className="row" style={{ background: "#ebe9e9" }}>

                                <div className="col-md-6">
                                  <b>State Name</b>
                                </div>

                                <div className="col-md-6 text-end">
                                  {tollDetails.state_name || "NA"}
                                </div>

                              </div>

                            </div>

                          </div>

                        )}

                      </div>

                    </div>

                  </div>

                </div>

              </div>

              <Footer />

            </div>

          </div>

        </div>

      </div>
    </>
  );
};

export default Pan;